import "./ThuongMai.css";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,

  PieChart,
  Pie,
  Cell,
} from "recharts";

const chartData = [
  { month: "Tháng 1", "Năm 2023": 65, "Năm 2024": 82 },
  { month: "Tháng 2", "Năm 2023": 78, "Năm 2024": 96 },
  { month: "Tháng 3", "Năm 2023": 82, "Năm 2024": 102 },
  { month: "Tháng 4", "Năm 2023": 95, "Năm 2024": 118 },
  { month: "Tháng 5", "Năm 2023": 118.22, "Năm 2024": 128.45 },
  { month: "Tháng 6", "Năm 2023": 80, "Năm 2024": 98 },
  { month: "Tháng 7", "Năm 2023": 84, "Năm 2024": 105 },
  { month: "Tháng 8", "Năm 2023": 86, "Năm 2024": 108 },
  { month: "Tháng 9", "Năm 2023": 92, "Năm 2024": 115 },
  { month: "Tháng 10", "Năm 2023": 90, "Năm 2024": 112 },
  { month: "Tháng 11", "Năm 2023": 95, "Năm 2024": 118 },
  { month: "Tháng 12", "Năm 2023": 100, "Năm 2024": 125 }
];


const pieData = [
  {
    name: "Bán lẻ hàng hóa",
    value: 78.65,
    percent: 61.3,
    color: "#2563EB"
  },
  {
    name: "Dịch vụ lưu trú, ăn uống",
    value: 22.18,
    percent: 17.3,
    color: "#10B981"
  },
  {
    name: "Dịch vụ khác",
    value: 19.42,
    percent: 15.1,
    color: "#F59E0B"
  },
  {
    name: "Du lịch lữ hành",
    value: 5.12,
    percent: 4.0,
    color: "#6366F1"
  },
  {
    name: "Khác",
    value: 3.08,
    percent: 2.3,
    color: "#2563EB"
  }
];

function ThuongMai() {
  return (
    <div className="bao-cao-cong-nghiep-page">

      {/* HEADER */}
      <div className="page-header">
        <div>
          <h1>Báo cáo hoạt động thương mại</h1>

<div className="breadcrumb">
    Trang chủ &gt; Thương mại &gt; Báo cáo hoạt động thương mại
</div>
        </div>

        <button className="guide-btn">
          Hướng dẫn
        </button>
      </div>

{/* FILTER */}
<div className="filter-card">

    <div className="filter-grid">

        <div className="form-group">
            <label>
                Kỳ báo cáo <span>*</span>
            </label>

            <select>
                <option>Tháng 05/2024</option>
            </select>
        </div>

        <div className="form-group">
            <label>
                Từ ngày <span>*</span>
            </label>

            <input
                type="date"
                defaultValue="2024-05-01"
            />
        </div>

        <div className="form-group">
            <label>
                Đến ngày <span>*</span>
            </label>

            <input
                type="date"
                defaultValue="2024-05-31"
            />
        </div>

        <div className="form-group">
            <label>
                Đơn vị báo cáo <span>*</span>
            </label>

            <select>
                <option>Xã Mỹ Đức</option>
            </select>
        </div>

        <div className="filter-btn-wrapper">
            <button className="load-btn">
                Lấy dữ liệu
            </button>
        </div>

    </div>

</div>

      {/* CONTENT */}
      <div className="report-layout">

        {/* LEFT */}
        <div className="main-content">

<div className="kpi-grid">

    <div className="kpi-card">

        <div className="kpi-icon blue">
            <i className="fa-solid fa-cart-shopping"></i>
        </div>

        <div className="kpi-content">
            <h4>Tổng mức bán lẻ hàng hóa (tỷ đồng)</h4>
            <h2>128,45</h2>
            <p>↑ 8,6% so với kỳ trước</p>
        </div>

    </div>

    <div className="kpi-card">

        <div className="kpi-icon green">
            <i className="fa-solid fa-bag-shopping"></i>
        </div>

        <div className="kpi-content">
            <h4>Doanh thu dịch vụ (tỷ đồng)</h4>
            <h2>45,28</h2>
            <p>↑ 6,3% so với kỳ trước</p>
        </div>

    </div>

    <div className="kpi-card">

        <div className="kpi-icon orange">
            <i className="fa-solid fa-store"></i>
        </div>

        <div className="kpi-content">
            <h4>Tổng kim ngạch XK (tỷ đồng)</h4>
            <h2>12,36</h2>
            <p style={{color:"#DC2626"}}>
                ↓ 12,1% so với kỳ trước
            </p>
        </div>

    </div>

    <div className="kpi-card">

        <div className="kpi-icon purple">
            <i className="fa-solid fa-shop"></i>
        </div>

        <div className="kpi-content">
            <h4>Số cơ sở thương mại</h4>
            <h2>356</h2>
            <p>↑ 3 cơ sở so với kỳ trước</p>
        </div>

    </div>

</div>

          {/* CHART */}
          <div className="chart-grid">

            <div className="card">

    <div className="chart-header">

        <h3>
    TỔNG MỨC BÁN LẺ HÀNG HÓA
    <span>(Tỷ đồng)</span>
</h3>

    </div>

    <div className="bar-chart-wrapper">

        <ResponsiveContainer
            width="100%"
            height={260}
        >
            <BarChart data={chartData}>

                <XAxis dataKey="month" />

                <YAxis />

                <Tooltip />

                <Legend />

                <Bar
                    dataKey="Năm 2023"
                    fill="#9EC5FE"
                    radius={[4,4,0,0]}
                />

                <Bar
                    dataKey="Năm 2024"
                    fill="#2563EB"
                    radius={[4,4,0,0]}
                />

            </BarChart>
        </ResponsiveContainer>

    </div>

</div>

            <div className="card">

    <div className="chart-header">
        <h3>
    CƠ CẤU DOANH THU THEO LOẠI HÌNH
    <span>(Tỷ đồng)</span>
</h3>
    </div>

    <div className="pie-layout">

        {/* DONUT */}

        <div className="pie-chart-area">

            <ResponsiveContainer
                width="100%"
                height={240}
            >
                <PieChart>

                    <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={85}
                        paddingAngle={2}
                        dataKey="value"
                    >
                        {pieData.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={entry.color}
                            />
                        ))}
                    </Pie>

                </PieChart>

            </ResponsiveContainer>

            <div className="donut-center">
                <div className="donut-value">
    128,45
</div>

<div className="donut-unit">
    Tỷ đồng
</div>
            </div>

        </div>

        {/* LEGEND */}

        <div className="pie-legend">

            {pieData.map((item,index)=>(
                <div
                    key={index}
                    className="legend-item"
                >

                    <div className="legend-left">

                        <span
                            className="legend-dot"
                            style={{
                                background:item.color
                            }}
                        />

                        <span>
                            {item.name}
                        </span>

                    </div>

                    <strong className="legend-value">
    {item.value.toFixed(2).replace(".", ",")}
    {" "}
    ({item.percent.toFixed(1).replace(".", ",")}%)
</strong>

                </div>
            ))}

        </div>

    </div>

</div>

          </div>

{/* TABLE */}
<div className="report-table-card">

    <div className="report-table-header">

        <h3>
            TÌNH HÌNH SẢN XUẤT CÔNG NGHIỆP
        </h3>

        <span>
            Đơn vị tính: Tỷ đồng
        </span>

    </div>

    <div className="table-wrapper">

        <table className="report-table">

            <thead>

                <tr>
    <th style={{width:"60px"}}>STT</th>
    <th>Chỉ tiêu</th>
    <th>Đơn vị tính</th>
    <th>Tháng 05/2024</th>
    <th>Tháng 04/2024</th>
    <th>Lũy kế từ đầu năm</th>
    <th>So với kỳ trước (%)</th>
    <th>So với cùng kỳ (%)</th>
</tr>

            </thead>

            <tbody>

<tr>
    <td>1</td>
    <td className="text-left">
        Tổng mức bán lẻ hàng hóa
    </td>
    <td>Tỷ đồng</td>
    <td>128,45</td>
    <td>118,22</td>
    <td>612,35</td>
    <td className="up-value">↑ 8,6%</td>
    <td className="up-value">↑ 9,2%</td>
</tr>

<tr>
    <td>2</td>
    <td className="text-left">
        Doanh thu dịch vụ
    </td>
    <td>Tỷ đồng</td>
    <td>45,28</td>
    <td>42,62</td>
    <td>211,47</td>
    <td className="up-value">↑ 6,3%</td>
    <td className="up-value">↑ 7,1%</td>
</tr>

<tr>
    <td>3</td>
    <td className="text-left">
        Tổng kim ngạch xuất khẩu
    </td>
    <td>Tỷ đồng</td>
    <td>12,36</td>
    <td>11,03</td>
    <td>56,78</td>
    <td className="up-value">↑ 12,1%</td>
    <td className="up-value">↑ 10,4%</td>
</tr>

<tr>
    <td>4</td>
    <td className="text-left">
        Tổng kim ngạch nhập khẩu
    </td>
    <td>Tỷ đồng</td>
    <td>8,45</td>
    <td>7,92</td>
    <td>38,21</td>
    <td className="up-value">↑ 6,7%</td>
    <td className="up-value">↑ 5,8%</td>
</tr>

<tr>
    <td>5</td>
    <td className="text-left">
        Số cơ sở thương mại
    </td>
    <td>Cơ sở</td>
    <td>356</td>
    <td>353</td>
    <td>356</td>
    <td className="up-value">↑ 0,8%</td>
    <td className="up-value">↑ 2,3%</td>
</tr>

</tbody>

        </table>

    </div>

</div>

{/* NOTE + FILE */}
<div className="bottom-grid">

    {/* GHI CHÚ */}
    <div className="note-card">

        <div className="section-title">
            Ghi chú
        </div>

        <div className="note-wrapper">

            <textarea
                maxLength={500}
                placeholder="Nhập ghi chú (nếu có)..."
                className="note-textarea"
            />

            <span className="note-counter">
                0/500
            </span>

        </div>

    </div>

    {/* FILE */}
    <div className="upload-card">

    <div className="section-title">
        Tài liệu đính kèm
    </div>

    <div className="upload-area">

        <div className="upload-top">

            <div className="upload-icon">
                <i className="fa-solid fa-cloud-arrow-up"></i>
            </div>

            <div className="upload-text">
                Kéo thả file vào đây hoặc
            </div>

            <label className="choose-file-btn">
                Chọn file
                <input type="file" hidden />
            </label>

        </div>

        <div className="upload-format">
            Định dạng: .pdf, .doc, .docx, .xls, .xlsx
        </div>

        <div className="upload-size">
            Dung lượng tối đa 20MB
        </div>

    </div>

</div>

</div>

          {/* ACTION */}
          <div className="action-row">

            <button className="outline-btn">
              Quay lại
            </button>

            <button className="outline-btn">
              Lưu nháp
            </button>

            <button className="primary-btn">
              Gửi báo cáo
            </button>

          </div>

        </div>

{/* RIGHT */}
<div className="report-sidebar">

    {/* THÔNG TIN */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            THÔNG TIN KỲ BÁO CÁO
        </h3>

        <div className="sidebar-info-row">
            <span>Kỳ báo cáo</span>
            <strong>Tháng 05/2024</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Loại báo cáo</span>
            <strong>Báo cáo hoạt động thương mại</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Ngày tạo</span>
            <strong>02/06/2024 09:15</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Hạn gửi</span>
            <strong>05/06/2024 23:59</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Trạng thái</span>

            <span className="status-badge warning">
                Chưa gửi
            </span>
        </div>

    </div>

    {/* TIẾN ĐỘ */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
    TIẾN ĐỘ BÁO CÁO THƯƠNG MẠI
</h3>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot active"></span>
                <span>Báo cáo hoạt động thương mại</span>
            </div>

            <span className="status-badge warning">
                Chưa gửi
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo chợ</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo siêu thị, TTTM</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo bán hàng đa cấp</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo xúc tiến TM</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo thương mại điện tử</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

    </div>

    {/* HƯỚNG DẪN */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            TÀI LIỆU HƯỚNG DẪN
        </h3>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn lập báo cáo hoạt động thương mại</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Mẫu báo cáo hoạt động thương mại</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo chợ</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo siêu thị, TTTM</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo TM điện tử</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-footer">
            Xem tất cả
            <i className="fa-solid fa-arrow-right"></i>
        </div>

    </div>

</div>

      </div>

    </div>
  );
}

export default ThuongMai;